import preventDefault from "@grrr/utils/functions/preventDefault";

const json = (response) => {
    return response.json();
};

export const newsLetterSubmit = function (el) {
    const feedback = document.querySelectorAll(".newsletter__result");
    let submitting = false;
    el.addEventListener("submit", function (event) {
        preventDefault(event);
        if (!submitting) {
            el.querySelector("[type='submit']").innerHTML =
                "Sending...&#8201;";
            submitting = true;
            const form = el;
            const data = new FormData(form);

            fetch("/wp-admin/admin-ajax.php", {
                method: "post",
                body: data,
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                },
            })
                .then(json)
                .then((response) => {
                    feedback.forEach(function (item) {
                        item.innerHTML = response.feedback;
                    });
                    submitting = false;
                    el.querySelector("[type='submit']").innerHTML =
                        "&nbsp;&nbsp;&nbsp;Submit&nbsp;&nbsp;&nbsp;";
                    feedback.forEach(function (item) {
                        item.style.display = "block";
                        if (response.success == true) {
                            item.classList.add("success");
                            item.classList.remove("error");
                            el.querySelector('[name="email"]').value = "";
                        } else {
                            item.classList.add("error");
                            item.classList.remove("success");
                        }
                    });
                })
                .catch((error) => {});
        }
    });
};
